// extracted by mini-css-extract-plugin
module.exports = {"base":"sidebar-module--base--_8jve","apple":"sidebar-module--apple--25J4-"};